<template>
    <div class="section">
        <div class="container-fluid text-center p-0">
            <h1 class="col-12 p-0">Hello<label>.</label></h1>

            <h2 class="title">Você quer se especializar em <span>cloud computing</span><label>?</label></h2>

            

        </div>
    </div>
</template>

<script>

export default {
    name: 'hello-section'
}
</script>

<style scoped lang="scss">

h1 {
    font-size: 30vw;
    

    label {
        color: #4834d4;
    }
}

h2 {
    font-size: 2em;

    span {
        text-decoration: underline #4834d4;
    }
}

</style>
